<template>
  <div class="crumbs">
    <div class="widthStyle">

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(node,index) in sameHierarchyList" :key="index" class="guidBox" >
          <span  class="title"  @click="goPath(node.id)">
            {{node.name}}
            <div class="childBox">
              <li v-for="(item,indexc) in node.sameParentIdList" v-if="item.id!=node.id" :key="indexc" @click="goPath(item.id)">{{item.name}}</li>
            </div>
          </span>


        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
  export default ({
    name: "breadcrumbGuid",
    data() {
      return{
        childIndex:'',
        isShowChildList:false,
        clickNumber:0,//点击同一个项的次数
        sameHierarchyList:[],//导航数据
      }
    },
    methods:{
      loadBreadcrumbGuid(sameHierarchyList){//导航树形结构数据，加载结束层级目录id
        if(sameHierarchyList){
          this.sameHierarchyList = sameHierarchyList;
         }
      },
      //点击路径项，进行下拉列表的展示与隐藏
      showChildList(index) {
        /* if(this.childIndex===index){
          if(this.clickNumber%2===0){
            this.isShowChildList=false;
          }else{
            this.isShowChildList=true;
          }
          this.clickNumber++;
        }else{
          this.isShowChildList=true;
          this.clickNumber=0;
        }
        this.childIndex=index; */
      },
      //点击下拉列表中的内容，进行跳转
      goPath(path){
        if(!path)return;
        this.$router.push({
          path: "/knowledgeMarket",
          query: {
            "searchText": '',
            "searchType": '',
            "hiddenSearchType": path
          }
        });
      }
    }
  })
</script>

<style lang="scss" scoped>
  .crumbs {
    background: $color-primary;
  }
  li{
    list-style: none;
  }
  .crumbs>>>.el-breadcrumb__inner {
    color: #fff;
  }
  .crumbs>>>.el-breadcrumb{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .crumbs>>>.el-icon-arrow-right {
    color: #fff;
  }
  .widthStyle {
    width: 80%;
    margin: 0 auto;
  }
  .guidBox>>>.el-breadcrumb__inner .title{
    position: relative;
    padding: 15px 0;
    display: inline-block;
    &:hover{
      cursor: pointer;
    }
  }
  .guidBox>>>.el-breadcrumb__inner .title:hover{
    color: $color-primary;
    background: #fff;
    .childBox{
      display: block;
    }

  }
  .childBox{
    position: absolute;
    top: 44px;
    left:0px;
    z-index: 10;
    background: $color-primary;
    display: none;
    color: #fff;
    min-width: 250px;
    box-shadow: 3px 0px 3px rgba(0,0,0,0.4),
                -3px 0px 3px rgba(0,0,0,0.4),
                0px 3px 3px rgba(0,0,0,0.4),
                0px 0px 0px rgba(0,0,0,0.4);
    box-sizing: border-box;
  }
  .childBox li{
    padding: 10px 5px;
    border: 1px solid $color-primary;
    border-bottom: 1px solid #fff;
    cursor: pointer;

  }
  .childBox li:hover{
    background: #fff;
    color: $color-primary;
    border: 1px solid $color-primary;
    box-sizing: border-box;
  }
  .childBox li:last-of-type{
    border-bottom:none;
  }
  .el-dropdown{
    color: #fff;
  }
  .el-icon--right{
    display: none;
  }
  >>>.popper__arrow{
    display: none;
  }
  .el-popper{
    margin-top: 15px;
  }
  .el-dropdown-link{
    cursor: pointer;
  }
  .el-dropdown-menu{
    padding: 0px;
    background-color: $color-primary;
    /* border-top: none; */
  }
  .el-dropdown-menu__item{
    border-bottom: 1px solid #fff;
    color: #fff;
  }
  .colorRed{
    color: $color-primary !important;
    background-color: #fff;
  }
  .colorRed:hover{
    color: $color-primary !important
  }
</style>



// WEBPACK FOOTER //
// src/components/breadcrumbGuid.vue